import { createSlice } from "@reduxjs/toolkit";

import { IUiInitialState, ValidationErrors } from "../../shared/interfaces/ui";

const initialState: IUiInitialState = {
    isVisibleCalendarInSheduleHeader: false,
    activeCategoryInNav: "schedule",
    patientDoctorSelectorInDrawer: "patient",
    toggleServiceDrawer: false,
    isLoading: false,
    isLocalLoading: false,
    isEditAppointment: false,
    isVisibleDentalFormulaModal: false,
    isVisibleModalDialog: false,
    errors: {} as ValidationErrors,
};

const uiSlice = createSlice({
    name: "ui",
    initialState,
    reducers: {
        toggleVisibilityCalendarInScheduleHeader: (state, action) => {
            state.isVisibleCalendarInSheduleHeader = action.payload;
        },
        setActiveCategoryInNav: (state, action) => {
            state.activeCategoryInNav = action.payload;
        },
        setPatientDoctorSelectorInDrawer: (state, action) => {
            state.patientDoctorSelectorInDrawer = action.payload;
        },
        setToggleServiceDrawer: (state, action) => {
            state.toggleServiceDrawer = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setLocalLoading: (state, action) => {
            state.isLocalLoading = action.payload;
        },
        setIseditAppointment: (state, action) => {
            state.isEditAppointment = action.payload;
        },
        setErrors: (state, action) => {
            state.errors = action.payload;
        },
        setIsVisibleDentalFormulaModal: (state, action) => {
            state.isVisibleDentalFormulaModal = action.payload;
        },
        setIsVisibleModalDialog: (state, action) => {
            state.isVisibleModalDialog = action.payload;
        },
    },
});

export const {
    toggleVisibilityCalendarInScheduleHeader,
    setActiveCategoryInNav,
    setPatientDoctorSelectorInDrawer,
    setToggleServiceDrawer,
    setLoading,
    setLocalLoading,
    setIseditAppointment,
    setErrors,
    setIsVisibleDentalFormulaModal,
    setIsVisibleModalDialog,
} = uiSlice.actions;
export default uiSlice.reducer;
